module.exports = new __parcel__URL__("shortcuts-preview-dark.ee547f9e.svg").toString();